import MicroeconomicsPage from './MicroeconomicsPage.vue';
import MicroeconomicsDetailsPage from './MicroeconomicsDetailsPage.vue';

export * from './types';
export {
    MicroeconomicsPage as default,
    MicroeconomicsDetailsPage
};
